<template>
  <base-section
  id="hero"
  space="0"
  >
    <v-img
      :max-height="minHeight"
      :src="require('@/assets/back.jpg')"
      gradient="to bottom, rgba(236, 242, 216, 0.85), rgba(255,255,255,.6)"
    >
      <v-container class="fill-height">
        <v-responsive
          class="d-flex align-center mx-auto"
          height="100%"
          width="100%"
        >
          <v-img
          :src="require('@/assets/logo2.png')"
          max-height="150"
          width="100%"
          contain
          id="img2"
          />
          <br>
          <base-heading
            size="text-h2"
            weight="bold"
            id="heading1"
            title="28th IEEE Latin American Test Symposium 2027"
          />
<br>
          <base-subheading
            size="text-h3"
            weight="bold"
            id="heading2"
            title="April 13-16, 2027, Lima, Peru"
          />
          <div class="d-flex flex-md-row flex-column">
            <!-- Left side buttons container -->
            <div class="d-flex flex-column pa-2">
          <!---
          <v-badge
            bordered
            color="success"
            overlap
          >
            <base-btn
            to="program"
            >
              Program
            </base-btn>
          </v-badge>
          <span class="font-weight-bold ml-6 mr-4 my-4"></span>
          <v-badge
            bordered
            color="success"
            overlap
          >
            <base-btn
            to="proceedings"
            >
              Preliminary Papers
            </base-btn>
          </v-badge>
          <v-badge
            bordered
            color="success"
            overlap
          >
            <base-btn
            to="/registration"
            width="100%"
            >
              Registration
            </base-btn>
            <br><br>
          </v-badge>
          <v-badge
            bordered
            color="success"
            overlap
          >
            <base-btn
            to="/program"
            width="100%"
            >
              Technical Program
            </base-btn>
            <br><br>
          </v-badge>
          <v-badge
            bordered
            color="success"
            overlap
          >
            <base-btn
            to="cfp"
            width="100%"
            >
              Call for late contributions
            </base-btn>
            <br><br>
          </v-badge>
          <v-badge
            bordered
            color="success"
            overlap
          >
          <base-btn
            to="/venue/san-andres"
            width="100%"
            style="padding: 15px"
          >
          Travel Book
          </base-btn>

          </v-badge>
          --->
          <v-badge
            bordered
            color="primary"
            overlap
          >
            <base-btn
            to="/cfp"
            width="100%"
            >
              Preliminary Call for Papers
            </base-btn>
            <br><br>
          </v-badge>
          <v-badge
            bordered
            color="primary"
            overlap
          >
            <base-btn
            to="/venue"
            width="100%"
            >
              Venue
            </base-btn>
          </v-badge>
        </div>
        <!-- Right side alert -->
         <br><br>
        <news-section
          :latestNews="latestNews"
          class="ml-md-auto align-self-center elevation-20 mt-mobile"
        >
        </news-section>
      </div>

        </v-responsive>
      </v-container>
    </v-img>
  </base-section>
</template>

<script>
import NewsSection from "@/components/base/NewsSection.vue"

  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: false },
    },
    components: {
      NewsSection,
    },

    data: () => ({
      latestNews: [
      {
        date: 'June 2026',
        text: 'Preliminary Call for Papers is out.',
        link: '/cfp',
      },
      ],
    }),

    computed: {
      minHeight () {
      return this.$vuetify.breakpoint.mdAndUp
        ? '90vh'
        : 'none'
      },
    },
  }
</script>

<style>
#heading1, #heading2 {
  color: #6663A6 !important;
  text-shadow:
    -0.5px -0.5px 0 white,
    0.5px -0.5px 0 white,
    -0.5px 0.5px 0 white,
    0.5px 0.5px 0 white,
    -0.5px 0 0 white,
    0.5px 0 0 white,
    0 -0.5px 0 white,
    0 0.5px 0 white;
}
#img1 > .v-image__image, #img2 > .v-image__image {
  background-position: unset !important;
}
</style>
